class MainBundles extends HTMLElement {
  constructor() {
    super();
    this.steps = this.querySelectorAll('[data-step]')
    this.sizesAvailable = this.querySelectorAll('.main-bundles__item');
    this.bundlesLimit = this.dataset.bundlesLimit;
    this.productsContainers = this.querySelectorAll('.main-bundles__products');
    this.addToBagButton = this.querySelector('.main-bundles__cart-footer--addToBag');
    this.goBackButton = this.querySelector('.main-bundles__cart-footer--goBack');
    this.nextButton = this.querySelector('.main-bundles__cart-footer--next');
    this.errorMessage = this.querySelector('.main-bundles__cart-footer--error');
    this.stepProgress = document.querySelectorAll('.bundles-steps__step');
    this.preCart = this.querySelector('.main-bundles__cart');
    this.addProductsButtons = this.querySelectorAll('.card-bundle__add-to-bundle');
    this.itemRemoveButton = this.querySelectorAll('.main-bundles__cart-item--remove');
    this.cartHeading = this.querySelector('.main-bundles__cart-heading');
    this.productAddedNotification = this.querySelector('.main-bundles__notification.item-added');
    this.bundleAddedNotification = this.querySelector('.main-bundles__notification.bundle-added');
    this.notificationClose = this.querySelectorAll('.main-bundles__notification-close')
    this.alertPopUp = this.querySelector('.main-bundles__alert');
    this.alertContinue = this.alertPopUp.querySelector('.continue');
    this.alertExit = this.alertPopUp.querySelector('.exit');
    this.infoBanners = document.querySelectorAll('.info-banner')
    this.goBackPopUpLink = '';
    this.currentScrollTop = 0;

    this.init();
  }

  setListeners() {
    this.sizesAvailable.forEach((item) => {
      item.addEventListener('click', () => this.chooseSize(item));

      // Keyboard accessibility: Enter and Space keys
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.chooseSize(item);
        }
      });
    });

    this.goBackButton.addEventListener('click', () => this.goBack())

    this.addProductsButtons.forEach((button) => {
      button.addEventListener('click', () => this.addProduct(button))
    })

    this.itemRemoveButton.forEach((button) => {
      button.addEventListener('click', () => this.removeProduct(button))
    })

    this.cartHeading.addEventListener('click', () => {

      const step = this.getLocalStorage().step;

      if (step == 1) return;

      this.openCartItems();
    })

    this.alertContinue.addEventListener('click', () => this.goBackPopUpLink == '' ? this.newSize() : location.href = this.goBackPopUpLink);

    const alertCloseButton = this.alertPopUp.querySelector('.main-bundles__alert-close');
    if (alertCloseButton) {
      alertCloseButton.addEventListener('click', () => this.toggleGoBackPopUp(false));
    }
    this.alertExit.addEventListener('click', () => this.toggleGoBackPopUp(false));

    this.addToBagButton.addEventListener('click', () => {
      if (!!!this.addToBagButton.classList.contains('disabled')) this.addBundle(this.addToBagButton)
    })

    this.nextButton.addEventListener('click', () => {
      if (this.nextButton.classList.contains('disabled')) return;

      this.nextStep();
    })

    this.productAddedNotification.addEventListener('click', (e) => this.openCartDrawer(e));
    this.bundleAddedNotification.addEventListener('click', (e) => this.openCartDrawer(e));

    this.notificationClose.forEach(close => close.addEventListener('click', () => close.closest('.main-bundles__notification').classList.remove('show')))

    window.addEventListener('scroll', () => {
      // if (window.innerWidth <= 989) this.toggleCart();
      this.stickyCartTop()
    })

    window.addEventListener('click', (e) => {
      let link = e.target.closest('a');
      let noRedirectURL = location.href + '#';

      if (!link || link.href == location.href || link.href == noRedirectURL) return;

      let selectedProducts = this.getLocalStorage().selectedProducts;

      if (selectedProducts.length != 0) {
        e.preventDefault()
        this.toggleGoBackPopUp(true)
        this.goBackPopUpLink = link.href
      }
    })
  }

  reRenderShopifySections = (response, selector = "[data-rerender]") => {

    return Object.keys(response.sections).forEach((key) => {
      const updatedNode = new DOMParser().parseFromString(response.sections[key], "text/html").querySelectorAll(selector);

      document.querySelector(`[id^="shopify-section-"][id*="${key}"]`)?.querySelectorAll(selector).forEach((node, index) => {
        if (updatedNode[index]) node.replaceWith(updatedNode[index]);
      });
    });
  };

  async addBundle(button) {
    try {
      let { selectedProducts, selectedSize: bundleSize } = this.getLocalStorage();

      if (selectedProducts.length < Number(this.preCart.dataset.min)) return;

      document.querySelector('body').classList.add('loading')

      let bundleId = new Date().getTime();

      let payload = {
        'items': []
      }

      selectedProducts.forEach((product, index) => {

        let discountType = this.preCart.dataset.discountType;
        let itemPercentage = this.preCart.dataset.discount;

        if (discountType == 'product_offer') itemPercentage = this.preCart.dataset.discount.split(',')[index]

        payload.items.push(
          {
            'id': product.id,
            'quantity': 1,
            'properties': {
              'itemDiscount': itemPercentage,
              '_bundleId': `${bundleId}`,
              '_bundleType': discountType,
              '_bundleSize': `${bundleSize}-${bundleId}`,
              '_purchase_type': 'one-time'
            }
          }
        )
      })

      let sections = "mini-cart,header,cart-notification,main-cart"

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sections,
          ...payload
        })
      })

      const response = await res.json()

      this.reRenderShopifySections(response)

      this.setDefaultLocalStorage()
      this.renderPage()

      this.addBundleNotification(button);
    } catch (error) {

      console.log(error);
      this.setErrorMessage(true)

    } finally {

      document.querySelector('body').classList.remove('loading')
      if (this.cartHeading.classList.contains('opened')) this.cartHeading.click();

    }
  }

  openCartDrawer(e) {
    if (e.target.closest('.main-bundles__notification-close')) return;
    else {
      e.target.closest('.main-bundles__notification').querySelector('.main-bundles__notification-close').click();

      document.querySelector('.header__utility-item--cart').dispatchEvent(
        new CustomEvent('toggleCart', {
          bubbles: true,
          composed: true,
          detail: {
            key: 'notification',
            event: e,
          },
        })
      )

    }
  }

  stickyCartTop() {
    this.scrollPosition = document.querySelector('body').getBoundingClientRect().top

    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (!this.preCart.firstElementChild) return;

    let { height } = this.preCart.firstElementChild.getBoundingClientRect();

    if (scrollTop > this.currentScrollTop) {
      let pixelPassed = window.innerHeight - height - 60

      if (pixelPassed < 0) this.preCart.firstElementChild.style.top = `${70 + pixelPassed - 40}px`
      else this.preCart.firstElementChild.style.top = '70px'
    }
    else this.preCart.firstElementChild.style.top = '110px'

    this.currentScrollTop = scrollTop;

    this.preCart.parentElement.getBoundingClientRect().top > 0
      ? this.preCart.style.position = 'fixed'
      : this.preCart.style.position = 'sticky'

    //mobile stop scrolling
    document.querySelector('body').style.top = `${this.scrollPosition}px`
  }

  toggleCart() {
    if (this.cartHeading.classList.contains('opened')) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    (scrollTop > this.currentScrollTop) ? this.preCart.classList.remove('show') : this.preCart.classList.add('show');

    this.currentScrollTop = scrollTop;
  }

  openCartItems() {
    if (window.innerWidth > 989) return;

    const itemsContainer = this.querySelector('.main-bundles__cart-items--container')
    const items = this.querySelector('.main-bundles__cart-items')
    const totalSavings = this.querySelector('.main-bundles__cart-footer--savings')

    if (this.cartHeading.classList.contains('opened')) {

      if (totalSavings) totalSavings.classList.remove('show')
      this.cartHeading.classList.remove('opened')
      if (itemsContainer) itemsContainer.style.paddingBottom = '0'

      setTimeout(() => {
        document.querySelector('body').classList.remove('overlay')

        if (-this.scrollPosition > document.querySelector('body').scrollHeight) this.querySelector('.main-bundles__container').scrollIntoView({ behavior: "smooth" })
        else window.scrollTo(0, -this.scrollPosition);

      }, 200);

    } else {

      if (totalSavings) totalSavings.classList.add('show')
      this.cartHeading.classList.add('opened')
      document.querySelector('body').classList.add('overlay')

      setTimeout(() => {
        let itemsContainerHeight = window.innerHeight
          - this.cartHeading.clientHeight
          - this.querySelector('.main-bundles__cart-bar--container')?.clientHeight
          - this.querySelector('.main-bundles__cart-footer')?.clientHeight
          - 90 // paddings

        if (itemsContainer) itemsContainer.style.paddingBottom = `${Math.min(items.scrollHeight, itemsContainerHeight)}px`
      }, 200);
    }
  }

  setErrorMessage(show = true, type) {
    let errorMessages = this.errorMessage.querySelectorAll('p')
    show ? this.errorMessage.classList.remove('hidden') : this.errorMessage.classList.add('hidden');

    if (type) {
      [...errorMessages].forEach(p => !!p.classList.contains(type) ? p.classList.remove('hidden') : p.classList.add('hidden'))
    } else errorMessages.forEach(p => !!p.classList.contains('default') ? p.classList.remove('hidden') : p.classList.add('hidden'))
  }

  goBack() {

    if (this.cartHeading.classList.contains('opened')) this.cartHeading.click();

    this.updateLocalStorage({ step: 1 })

    // Reset ARIA states when going back
    this.sizesAvailable.forEach(size => {
      size.classList.remove('selected');
      size.setAttribute('aria-pressed', 'false');
    });

    this.nextButton.classList.add('disabled');
    this.nextButton.setAttribute('aria-disabled', 'true');

    this.renderPage();
  }

  toggleGoBackPopUp(open = true) {
    if (open) {
      this.alertPopUp.classList.add('show');
      // Focus on the dialog when opened for accessibility
      const continueButton = this.alertPopUp.querySelector('.continue');
      if (continueButton) {
        setTimeout(() => continueButton.focus(), 100);
      }
    } else {
      this.alertPopUp.classList.remove('show');
    }
  }

  setDefaultLocalStorage() {
    localStorage.setItem('customBundlePage', JSON.stringify({
      step: 1,
      selectedSize: '',
      selectedProducts: [],
      itemPercentage: 0
    }))
  }

  getLocalStorage() {
    let defaultState = {
      step: 1,
      selectedSize: '',
      selectedProducts: [],
      itemPercentage: 0
    }

    let storedState = localStorage.getItem('customBundlePage')

    if (!storedState) return defaultState

    try {
      return { ...defaultState, ...JSON.parse(storedState) }
    } catch(e) {
      return defaultState
    }
  }

  updateLocalStorage(updates) {
    localStorage.setItem('customBundlePage', JSON.stringify({
      ...this.getLocalStorage(),
      ...updates
    }))
  }

  parseMoney(priceStr) {
    return Number(String(priceStr).replace(/[^\d.]/g, ''))
  }

  getCurrencySymbol(priceStr) {
    return String(priceStr).replace(/[\d.,\s]/g, '') || '$'
  }

  async chooseSize(item) {
    const sizeSelected = item.dataset.size

    document.querySelector('body').classList.add('loading')

    // Update ARIA states for all size items
    this.sizesAvailable.forEach(size => {
      size.classList.remove('selected');
      size.setAttribute('aria-pressed', 'false');
    });

    item.classList.add('selected');
    item.setAttribute('aria-pressed', 'true');

    let itemsRes = await fetch('/cart.js')
    let itemsJson = await itemsRes.json()
    let bundlesWithSizeSelected = 0;

    itemsJson.items.forEach(item => {
      if (item.properties._bundleSize?.includes(sizeSelected)) {
        bundlesWithSizeSelected += item.quantity;
      }
    });

    document.querySelector('body').classList.remove('loading')

    if (bundlesWithSizeSelected >= Number(this.bundlesLimit)) {
      this.setErrorMessage(true, 'bundle-limit')
      this.nextButton.classList.add('disabled')
      return;
    }

    this.nextButton.classList.remove('disabled');
    this.nextButton.setAttribute('aria-disabled', 'false');
    this.setErrorMessage(false);

    this.updateLocalStorage({ step: 2, selectedSize: sizeSelected })

    if (window.innerWidth > 989) return;

    this.nextButton.click();
  }

  newSize() {
    const { selectedSize } = this.getLocalStorage();

    if (this.preCart.dataset.size !== '') this.clearCartItems();
    this.preCart.dataset.size = selectedSize;

    this.toggleGoBackPopUp(false)
    this.renderPage();
  }

  nextStep() {
    const { selectedSize, selectedProducts } = this.getLocalStorage();

    document.querySelector('body').scrollIntoView({ behavior: 'smooth' })

    if (selectedProducts.length == 0) this.renderPage();
    else if (selectedSize !== this.preCart.dataset.size) {
      this.goBackPopUpLink = '';
      this.toggleGoBackPopUp();
    }
    else this.renderPage();

  }

  removeProduct(button) {
    let selectedProducts = this.getLocalStorage().selectedProducts;

    selectedProducts.splice(button.dataset.index, 1);

    this.updateLocalStorage({ selectedProducts });

    this.renderPage();
  }

  updateCards(selectedProducts) {
    this.addProductsButtons.forEach((button) => {

      button.closest('.card-bundle__buttons').querySelector('hh-quantity-input')._value = 1;

      // Limit cards regarding quantity already added to cart

      let quantityInCart = selectedProducts.filter(selectedProduct => selectedProduct.id == button.dataset.productId).length;

      if (quantityInCart == 0) {
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max = 2;
        button.closest('.main-bundles__product').classList.remove('disabled');
      } else if (quantityInCart == 1) {
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max = 1;
        button.closest('.main-bundles__product').classList.remove('disabled');
      } else {
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max = 0;
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input')._value = 0;
        button.closest('.main-bundles__product').classList.add('disabled');
      }

      // Limit cards regarding to cart products limit

      if (selectedProducts.length >= Number(this.preCart.dataset.max)) {
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max = 0;
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input')._value = 0;
        button.closest('.main-bundles__product').classList.add('disabled');
      } else if (selectedProducts.length == (Number(this.preCart.dataset.max) - 1)) {
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max = 1;
      }

      //Limit cards regards variant quantity

      if (button.dataset.quantity >= button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max) return;

      if (button.dataset.quantity == 1) {

        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max = 1;
        button.closest('.main-bundles__product').classList.remove('disabled');

      } else if (button.dataset.quantity <= 0) {
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input').max = 0;
        button.closest('.card-bundle__buttons').querySelector('hh-quantity-input')._value = 0;
        button.closest('.main-bundles__product').classList.add('sold-out');
      }

    })
  }

  setDiscount(selectedProducts, itemIndex) {
    let discountPercentage = this.preCart.dataset.discount;
    let discountType = this.preCart.dataset.discountType;

    let itemPrice = this.parseMoney(selectedProducts[itemIndex].price)
    let currencySymbol = this.getCurrencySymbol(selectedProducts[itemIndex].price)
    let itemOriginalPrice = selectedProducts[itemIndex].price

    if (discountType === 'traditional') {

      let itemPercentage = discountPercentage;
      let discountAmount = itemPrice * (discountPercentage / 100);
      let finalPrice = `${currencySymbol}${(Math.round((itemPrice - discountAmount) * 100) / 100).toFixed(2)}`;

      return { finalPrice, itemOriginalPrice, itemPercentage }

    } else if (discountType === 'product_offer') {

      let discountPercentages = discountPercentage.split(',');
      let itemPercentage = discountPercentages[itemIndex]

      let discountAmount = itemPrice * (itemPercentage / 100);
      let finalPrice = `${currencySymbol}${(Math.round((itemPrice - discountAmount) * 100) / 100).toFixed(2)}`;

      return { finalPrice, itemOriginalPrice, itemPercentage }

    } else {

      let discountPercentages = discountPercentage.split(',');
      let itemPercentage = discountPercentages[selectedProducts.length - 1]

      let discountAmount = itemPrice * (discountPercentages[selectedProducts.length - 1] / 100);
      let finalPrice = `${currencySymbol}${(Math.round((itemPrice - discountAmount) * 100) / 100).toFixed(2)}`;

      return { finalPrice, itemOriginalPrice, itemPercentage }
    }
  }

  addProduct(button) {
    if (button.closest('.main-bundles__product').classList.contains('disabled') ||
      button.closest('.main-bundles__product').classList.contains('sold-out')) return;

    const product = {
      id: button.dataset.productId,
      name: button.dataset.productName,
      price: button.dataset.productPrice,
      image: button.dataset.productImage
    }

    const quantity = button.closest('.card-bundle__buttons')?.querySelector('hh-quantity-input')?._value;

    let selectedProducts = this.getLocalStorage().selectedProducts;

    if (selectedProducts.length > Number(this.preCart.dataset.max)
      || selectedProducts.filter(selectedProduct => selectedProduct.id == product.id).length >= 2) return;

    if (button.closest('.main-bundles__products').dataset.size !== this.preCart.dataset.size && this.preCart.dataset.size != '') {
      selectedProducts = [];
    }

    for (let i = 0; i < quantity; i++) {
      selectedProducts.push(product)
    }

    this.updateLocalStorage({ selectedProducts });

    this.renderPage();
    // this.addProductNotification(button);
  }

  addProductNotification(button) {
    let image = document.createElement('img')
    let compareAtPrice = document.createElement('span')
    let price = document.createElement('span')
    let title = this.productAddedNotification.querySelector('.main-bundles__notification-title')
    let imageContainer = this.productAddedNotification.querySelector('.main-bundles__notification-image')
    let priceContainer = this.productAddedNotification.querySelector('.main-bundles__notification-price')

    image.src = button.dataset.productImage
    compareAtPrice.classList.add('compare-at-price')
    compareAtPrice.innerText = button.dataset.productCompareAtPrice
    price.classList.add('price')
    price.innerText = button.dataset.productPrice

    title.innerText = button.dataset.productName
    imageContainer.innerHTML = ''
    imageContainer.appendChild(image)
    priceContainer.innerHTML = ''
    priceContainer.appendChild(compareAtPrice)
    priceContainer.appendChild(price)

    this.productAddedNotification.classList.add('show')
    setTimeout(() => this.productAddedNotification.classList.remove('show'), 1200);
  }

  addBundleNotification(button) {
    let originalPrice = document.createElement('span')
    let price = document.createElement('span')
    let info = this.bundleAddedNotification.querySelector('.main-bundles__notification-items')
    let priceContainer = this.bundleAddedNotification.querySelector('.main-bundles__notification-price')

    originalPrice.classList.add('compare-at-price')
    originalPrice.innerText = button.dataset.originalPrice
    price.classList.add('price')
    price.innerText = button.dataset.finalPrice

    priceContainer.innerHTML = ''
    priceContainer.appendChild(originalPrice)
    priceContainer.appendChild(price)
    info.innerHTML = `${button.dataset.items}`

    this.bundleAddedNotification.classList.add('show')
    setTimeout(() => this.bundleAddedNotification.classList.remove('show'), 5000);
  }

  createItem(item, itemIndex, selectedProducts) {
    let imageContainer = item.querySelector('.main-bundles__cart-item--image')
    let infoContainer = item.querySelector('.main-bundles__cart-item--filled')
    let rightContainer = item.querySelector('.main-bundles__cart-item--right')

    if (selectedProducts[itemIndex]) {
      let title = document.createElement('h4')
      let image = document.createElement('img')
      let price = rightContainer.querySelector('.main-bundles__cart-item--price .final-price')
      let originalPrice = rightContainer.querySelector('.main-bundles__cart-item--price .original-price')
      let discount = document.createElement('span')

      discount.classList.add('main-bundles__cart-item--discount')

      let { finalPrice, itemOriginalPrice, itemPercentage } = this.setDiscount(selectedProducts, itemIndex);

      this.updateLocalStorage({ itemPercentage });

      title.textContent = selectedProducts[itemIndex].name;
      image.src = selectedProducts[itemIndex].image;
      discount.textContent = `${itemPercentage}% OFF`
      price.textContent = finalPrice;
      originalPrice.textContent = itemOriginalPrice;

      imageContainer.querySelector('svg')?.classList.add('hidden');
      imageContainer.querySelector('img')?.remove();
      imageContainer.appendChild(image);

      infoContainer.innerHTML = '';
      infoContainer.classList.remove('hidden');
      infoContainer.appendChild(title);
      infoContainer.appendChild(discount);

      rightContainer.classList.remove('hidden');
    } else {
      imageContainer.querySelector('img')?.remove();
      imageContainer.querySelector('svg')?.classList.remove('hidden');

      infoContainer.classList.add('hidden');
      rightContainer.classList.add('hidden');
    }
  }

  clearCartItems() {
    this.updateLocalStorage({ selectedProducts: [] })
  }

  renderCart(selectedProducts, step) {
    const preCartItems = this.preCart.querySelectorAll('.main-bundles__cart-item');
    const progressBar = this.preCart.querySelector('.main-bundles__cart-bar--progress');
    const progressBarContainer = this.preCart.querySelector('.main-bundles__cart-bar');
    const progressBarText = this.preCart.querySelector('.main-bundles__cart-bar--info .h4');
    const progressBarCounter = this.preCart.querySelector('.main-bundles__cart-bar--counter span');
    const cartStatus = document.getElementById('cart-status');
    const totalSavingsPlace = this.preCart.querySelector('.main-bundles__cart-footer--savings');
    const totalplace = this.preCart.querySelectorAll('.main-bundles__cart-footer--total');
    const activeStep = [...this.steps].find(container => !!!container.classList.contains('hidden'));
    const itemsContainer = this.querySelector('.main-bundles__cart-items--container')

    this.preCart.style.marginTop = `${activeStep.querySelector('.main-bundles__content-top')?.clientHeight + 40}px`

    preCartItems.forEach((item, index) => {
      this.createItem(item, index, selectedProducts)
    })

    if (selectedProducts.length >= Number(this.preCart.dataset.min)) {
      this.addToBagButton.classList.remove('disabled');
      this.addToBagButton.setAttribute('aria-disabled', 'false');
    } else {
      this.addToBagButton.classList.add('disabled');
      this.addToBagButton.setAttribute('aria-disabled', 'true');
    }

    // Cart by step

    if (step == 1) {

      if (totalSavingsPlace) totalSavingsPlace.classList.add('hidden')
      if (totalplace) totalplace.forEach(place => place.classList.add('hidden'))
      if (itemsContainer) itemsContainer.classList.add('hidden')
      this.goBackButton.classList.add('hidden')
      this.addToBagButton.classList.add('hidden')
      this.nextButton.classList.remove('hidden')
      this.cartHeading.querySelector('svg').classList.add('hidden')

    } else {

      if (totalSavingsPlace) totalSavingsPlace.classList.remove('hidden')
      if (totalplace) totalplace.forEach(place => place.classList.remove('hidden'))
      if (itemsContainer) itemsContainer.classList.remove('hidden')
      this.goBackButton.classList.remove('hidden')
      this.addToBagButton.classList.remove('hidden')
      this.nextButton.classList.add('hidden')
      this.cartHeading.querySelector('svg').classList.remove('hidden')

    }

    // Calculate total and savings

    let total = 0;
    let totalSavings = 0;
    let originalTotal = 0;
    let itemsNames = [];

    let currencySymbol = selectedProducts.length > 0 ? this.getCurrencySymbol(selectedProducts[0].price) : '$'

    selectedProducts.forEach((product, index) => {
      let finalPrice = preCartItems[index].querySelector('.final-price').textContent;

      if (!!!finalPrice) return;

      itemsNames.push(product.name)
      total += this.parseMoney(finalPrice)
      totalSavings += (this.parseMoney(product.price) - this.parseMoney(finalPrice))
      originalTotal += this.parseMoney(product.price)
    })

    itemsNames.join(',')
    totalSavingsPlace.querySelector('span').textContent = `${currencySymbol}${totalSavings.toFixed(2)}`
    totalplace.forEach(place => place.querySelector('span').textContent = `${currencySymbol}${total.toFixed(2)}`)

    // Progress bar
    const progressPercentage = (100 / Number(this.preCart.dataset.max)) * selectedProducts.length;
    progressBar.style.width = `${progressPercentage}%`;
    progressBarCounter.textContent = `0${selectedProducts.length}`;
    
    // Update ARIA attributes for progressbar
    if (progressBarContainer) {
      progressBarContainer.setAttribute('aria-valuenow', selectedProducts.length);
      progressBarContainer.setAttribute('aria-label', `Bundle progress: ${selectedProducts.length} of ${this.preCart.dataset.max} items`);
    }
    
    // Update cart status for screen readers
    if (cartStatus) {
      const itemText = selectedProducts.length === 1 ? 'item' : 'items';
      cartStatus.textContent = `${selectedProducts.length} ${itemText} in your bundle`;
    }

    progressBarText.querySelectorAll('span').forEach(span => span.classList.add('hidden'))

    if (selectedProducts.length == 0) {
      progressBarText.querySelector('span.start')?.classList.remove('hidden')
      return;
    }

    if (this.preCart.dataset.discountType === 'traditional') {

      //rendering the span corresponding to the number of items added
      if (Number(this.preCart.dataset.max) - selectedProducts.length <= 0) progressBarText.querySelector('span.finish')?.classList.remove('hidden')
      else progressBarText.querySelectorAll('span')[selectedProducts.length]?.classList.remove('hidden')

    } else {

      if (Number(this.preCart.dataset.max) - selectedProducts.length == 0) progressBarText.querySelector('span.finish')?.classList.remove('hidden')
      else progressBarText.querySelectorAll('span')[selectedProducts.length + 1]?.classList.remove('hidden')

    }

    this.addToBagButton.dataset.finalPrice = `${currencySymbol}${total.toFixed(2)}`
    this.addToBagButton.dataset.originalPrice = `${currencySymbol}${originalTotal.toFixed(2)}`
    this.addToBagButton.dataset.items = itemsNames

  }

  renderPage() {
    const bundleState = localStorage.getItem('customBundlePage');

    if (!!!bundleState) return;

    const { step, selectedSize, selectedProducts } = JSON.parse(bundleState);

    if (!!step) {

      // Render each step
      this.steps.forEach((container) => {
        container.dataset.step === `${step}` ? container.classList.remove('hidden') : container.classList.add('hidden');

        if (!!!this.infoBanners) return;

        this.infoBanners.forEach(banner => (Number(banner.dataset.hide) == step) ? banner.classList.add('hide') : banner.classList.remove('hide'))
      });

      // Render products depending on the size selected
      if (!!selectedSize) {
        if (this.preCart.dataset.size !== selectedSize) {
          if (this.preCart.dataset.size !== '') this.clearCartItems();
          this.preCart.dataset.size = selectedSize;
        }

        this.productsContainers.forEach((container) => {
          container.dataset.size === selectedSize ? container.classList.remove('hidden') : container.classList.add('hidden');
        });
      }

      if (step === 1) {
        this.goBackButton.classList.add('hidden')
        this.nextButton.classList.add('disabled')
        this.sizesAvailable.forEach(size => size.classList.remove('selected'))

        setTimeout(() => {
          this.querySelector('.main-bundles__container').scrollIntoView({ behavior: "smooth" })
        }, 100);

      } else this.goBackButton.classList.remove('hidden');

      // Steps progress bar functionality
      this.stepProgress.forEach((bar) => {

        if (Number(bar.dataset.step) < step) {
          bar.querySelector('.bundles-steps__step-bar').classList.remove('bundles-steps__step-bar--active')
          bar.querySelector('.bundles-steps__step-bar').classList.add('bundles-steps__step-bar--completed')
        }
        else if (Number(bar.dataset.step) == step) {
          bar.querySelector('.bundles-steps__step-bar').classList.remove('bundles-steps__step-bar--completed')
          bar.querySelector('.bundles-steps__step-bar').classList.add('bundles-steps__step-bar--active')
        } else {
          bar.querySelector('.bundles-steps__step-bar').classList.remove('bundles-steps__step-bar--active')
          bar.querySelector('.bundles-steps__step-bar').classList.remove('bundles-steps__step-bar--completed')
        }
      });

      // Render pre-cart
      this.renderCart(selectedProducts, step);

      // Cards experiences
      this.updateCards(selectedProducts);

      this.setErrorMessage(false)
    }
  }

  init() {
    this.setDefaultLocalStorage();
    this.setListeners();
    this.renderPage();
  }
}

customElements.define('main-bundles', MainBundles)
